import api from '../../services/api';
import { normalizeWZSourceCandidates, type WZSourceCandidates } from './wzLineSource';

/**
 * Deliveries each product can come from. `wzDocumentId` (edit of a saved
 * draft) counts that draft's own pins as available again.
 */
export async function fetchWZSourceCandidates(
  variantIds: string[],
  wzDocumentId?: string | null,
): Promise<WZSourceCandidates> {
  const ids = Array.from(new Set(variantIds.filter(Boolean))).sort();
  if (ids.length === 0) return {};
  const response = await api.get('/wz/source-candidates', {
    params: { variantIds: ids.join(','), ...(wzDocumentId ? { wzDocumentId } : {}) },
  });
  return normalizeWZSourceCandidates(response.data);
}
